export const findServiceFee = (brackets, amount) => {
  const bracket = (brackets || []).find(
    ({ lowBracket, highBracket }) =>
      amount >= lowBracket && (highBracket === null || amount < highBracket)
  );

  return bracket ? bracket.serviceFee : 0;
};
